<template>
  <div class="mt-1" :class="customClass">
    <!-- Vaccine section -->
    <!-- <div class="rounded-pill d-inline-block p-2 mt-2 mr-2 -bg-blue-grey text-small"
         v-if="professional.professional_vaccines.length > 0">
      <img src="/static/img/covid-vaccinated.png" width="24" alt="">
      {{ $t('message.covid.vaccinated') }} X{{professional.professional_vaccines.length}}
    </div> -->
    <!-- Covid-19 test section -->
    <div class="rounded-pill d-inline-block p-2 mt-2 -bg-blue-grey text-small"
         v-if="professional.professional_covid_test">
      <img src="/static/img/covid-test.png" width="24" alt="">
      {{ $t('message.covid.covid_test') }}: {{ professional.professional_covid_test.received_date | prettyOnlyDate }}
    </div>
    <!-- Criminal record section -->
    <div class="rounded-pill d-inline-block p-2 mt-2 -bg-blue-grey text-small"
         v-if="professional.criminal_record">
      <i class="fas fa-clipboard-check icon-profile text-success"></i>
      {{ $t('message.professional.criminal_record_check') }}<span v-if="diffYear(professional.criminal_record.record_date)"> : {{ professional.criminal_record.record_date | prettyOnlyMonthYear }}</span>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      professional: Object,
      customClass: String
    },
    methods: {
      diffYear (date) {
        let criminalDate = new Date(date)
        const currentDate = new Date()
        const diffInMilliseconds = currentDate - criminalDate
        const diffInYear = diffInMilliseconds / (1000 * 60 * 60 * 24 * 365.25)
        if (diffInYear < 1) {
          return true
        } else {
          return false
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/professional/components/ProfessionalVaccination.vue